module.exports = __webpack_public_path__ + "img/bottom_right_view_img.4ba6ce81.png";